/* eslint-disable @nx/enforce-module-boundaries */
import { BackArrow, BackArrowRTL, CirclePlus } from '@mybridge/icons';
import {
  Button,
  Card,
  HStack,
  IconButton,
  Progress,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { MyTestimonialsAskTestimonialModal } from './ask-for-testimonial-modal';
import { MyTestimonialsContext } from './context';
import { MyTestimonialsGiveTestimonialModal } from './give-testimonial-modal';
import { MyTestimonialsGivenListing } from './given';
import { MyTestimonialsReceivedListing } from './received';
import { MyTestimonialsRequestedListing } from './requested';
import { VStack } from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const MyTestimonials = forwardRef(({ ...props }, ref) => {
  const {
    giveTestimonialDisc,
    askTestimonialDisc,
    tab,
    setTab,
    setSelected,
    givenTestimonialsQuery,
    requestedTestimonialsQuery,
    receivedTestimonialsQuery,
    receivedTestimonialsPendingRequests,
    givenTestimonialsPendingRequests,
    requestedTestimonials,
  } = useContext(MyTestimonialsContext);
  const { t } = useTranslator();
  const direction = useDirection();
  const { back, query } = useRouter();

  // Set tab based on query parameter
  useEffect(() => {
    if (query.tab == '1') {
      setTab(1);
    }
  }, [query.tab, setTab]);

  const loading =
    givenTestimonialsQuery?.isFetching ||
    receivedTestimonialsQuery?.isFetching ||
    requestedTestimonialsQuery?.isFetching;
  return (
    <>
      <Card boxShadow="none">
        <Progress opacity={loading ? 1 : 0} h={1} isIndeterminate />
        <VStack pt={[0,2]}  pl={[2,6]} alignItems={"start"}>

        <Text fontWeight="400" color="brandPrimary.500" fontSize="20px">
        <IconButton size="sm" variant="transparent" onClick={() => back()} icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />} />
          {t('profileTestimonials.testimonials') || "Testimonials"}
        </Text>
        </VStack>
        <Stack p={[0,4]} pt={[4]}>
          <Stack direction={['column', 'row']}>
            <HStack>
              <Button
                borderRadius="full"
                color="brandPrimary.500"
                variant="ghost"
                leftIcon={<CirclePlus width={20} height={20} />}
                onClick={(e) => {
                  setSelected(null);
                  giveTestimonialDisc?.onOpen?.();
                }}
              >
                {t('profileTestimonials.giveTestimonial') || "Give a Testimonial"}
              </Button>
              <Button
                borderRadius="full"
                color="brandPrimary.500"
                variant="ghost"
                leftIcon={<CirclePlus width={20} height={20} />}
                onClick={(e) => {
                  setSelected(null);
                  askTestimonialDisc?.onOpen?.();
                }}
              >
                {t('profileTestimonials.askForTestimonial') || "Ask for a Testimonial"}
              </Button>
            </HStack>
          </Stack>
          <Tabs mt={4} index={tab} active={tab}>
            <TabList >
              <Tab onClick={(e) => setTab(0)}>
                {t('profileTestimonials.received') || "Received"}{' '}
                {receivedTestimonialsPendingRequests?.length
                  ? `(${receivedTestimonialsPendingRequests.length})`
                  : ''}
              </Tab>
              <Tab onClick={(e) => setTab(1)}>
                {t('profileTestimonials.given') || "Given"}{' '}
                {givenTestimonialsPendingRequests?.length
                  ? `(${givenTestimonialsPendingRequests.length})`
                  : ''}
              </Tab>
              <Tab onClick={(e) => setTab(2)}>
                {t('profileTestimonials.yourRequests') || "Your Requests"}{' '}
                {requestedTestimonials?.length
                  ? `(${requestedTestimonials.length})`
                  : ''}
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <MyTestimonialsReceivedListing />
              </TabPanel>
              <TabPanel>
                <MyTestimonialsGivenListing />
              </TabPanel>
              <TabPanel>
                <MyTestimonialsRequestedListing />
              </TabPanel>
            </TabPanels>
          </Tabs>
          {giveTestimonialDisc?.isOpen ? (
            <MyTestimonialsGiveTestimonialModal {...giveTestimonialDisc} />
          ) : (
            ''
          )}
          {askTestimonialDisc?.isOpen ? (
            <MyTestimonialsAskTestimonialModal {...askTestimonialDisc} />
          ) : (
            ''
          )}
        </Stack>
      </Card>
    </>
  );
});